




































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import * as Routes from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import { Location } from "vue-router";
import {
  DrivewealthWizardStep,
  InvestmentCustodian
} from "@/shared/types";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import InvestmentAccountLink from "@/shared/components/investments/InvestmentAccountLink.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthAccountMigrationStore } from "@/shared/store/drivewealthAccountMigration";
import { useUserStore } from "@/shared/store/user";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

enum InvestmentToView {
  None = "none",
  Tda = "tda",
  Drivewealth = "drivewealth",
}

@Component({
  components: {
    GenericLoadingSpinner,
    InvestmentLineChart,
    InvestmentAccountLink,
    HsabInvestmentAccountRedirectLink
  }
})
export default class MixedInvestmentPage extends Vue {
  investmentToView: InvestmentToView = InvestmentToView.None;
  formatCurrency = formatCurrency;


  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  investmentCustodian: InvestmentCustodian;

  featureFlagStore = useFeatureFlagStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthAccountMigrationStore = useDrivewealthAccountMigrationStore();
  userStore = useUserStore();
  hsabInvestmentStore = useHsabInvestmentStore();

  mounted () {
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.investmentDailyBalanceStore.loadCurrentDailyBalance({}).catch(_ => {
      return;
    });
    this.drivewealthStore.loadAccountSummariesV2({});
    this.drivewealthAccountMigrationStore.getAccountMigrationPeriodStatus();
  }

  get displayGraph (): boolean {
    return this.investmentCustodian !== InvestmentCustodian.Umb;
  }

  get displayRtqInstrumentAdjustmentCopy (): boolean {
    return false;
  }

  get isLoaded () {
    return this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
      this.drivewealthWizardStore.enrollmentTypeLoaded &&
      this.drivewealthWizardStore.isEnrollmentLoaded &&
      this.investmentDailyBalanceStore.currentBalanceIsLoaded &&
      this.investmentThresholdStore.thresholdsLoaded &&
      this.drivewealthStore.accountIdsLoaded;
  }

  get displayLegacyInvestmentDivesmentCopy (): boolean {
    // return true if user does not have account, AND has enough to open account, AND has legacy investments

    if (this.drivewealthStore.hasAnAccount) {
      return false;
    }

    return this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
      this.investmentThresholdStore.displayMigrationPeriodHsabInvestmentsRedirectLink;
  }

  get drivewealthRouteLocation (): Location {
    const accountId = this.drivewealthStore.accountIds.length ? this.drivewealthStore.accountIds[0] : 0;
    const hasMultipleDrivewealthAccounts = this.drivewealthStore.accountIds.length > 1;

    if (hasMultipleDrivewealthAccounts) {
      return { name: Routes.DrivewealthMultipleAccountSelection };
    } else if (accountId) {
      return { name: SharedRoutes.DrivewealthInvestmentAccountV2, params: { accountId: `${accountId}` }};
    }

    return { name: SharedRoutes.DrivewealthInvestmentAccount };
  }

  get hsabRouteLocation (): Location {
    return { name: Routes.HsabInvestmentAccount };
  }

  get showPreenrollCopy (): boolean {
    return this.featureFlagStore.flags.allowDrivewealthPreenrollment &&
      this.drivewealthWizardStore.isAllowedToPreenroll;
  }

  get drivewealthButtonCopy (): string {
    if (this.drivewealthStore.hasAnAccount) {
      return "HSA Invest";
    }

    if (this.investmentDailyBalanceStore.hasEnoughToOpenAccount) {
      return "Enroll in HSA Invest";
    }

    if (this.drivewealthWizardStore.isPreenrolled) {
      return "Manage HSA Invest Enrollment";
    }

    if (this.featureFlagStore.flags.allowDrivewealthPreenrollment && this.drivewealthWizardStore.isAllowedToPreenroll) {
      return "Enroll in HSA Invest";
    }

    return "Learn more about HSA Invest";
  }

  get drivewealthButtonBalance (): number {
    if (this.drivewealthStore.hasAnAccount) {
      return this.drivewealthStore.drivewealthAllAccountBalance;
    }

    return undefined;
  }
}
